import styled, { css } from "styled-components";

import { Paragraph } from "App/global-style";
import { ErrorWrapperProps } from "./interfaces";

const screenReaderOnlyStyling = css`
  height: 1px;
  left: -10000px;
  overflow: hidden;
  position: absolute;
  top: auto;
  width: 1px;
`;

export const ErrorWrapper = styled.div<ErrorWrapperProps>`
  margin-bottom: 56px;
  ${({ isVisible }: any) => !isVisible && screenReaderOnlyStyling}
  width: 100%;
`;

export const StyledUl = styled.ul`
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;

export const StyledA = styled.a`
  margin-right: 4px;
`;

export const StyledLi = styled.li`
  margin: 10px;
`;

export const InlineP = styled(Paragraph)`
  display: inline;
`;
